const blockAttributes = {
	title: {
		type: "string",
		default: "Payment link",
	},
	alignment: {
		type: "string",
		default: "center",
	},
	link: {
		type: "string",
	},
	text_color: {
		type: "string",
		default: "#000000",
	},
	textsize: {
		type: "string",
		default: "17px",
	},
};

export default blockAttributes;
